import {
  clearSrDocumentTypeAction,
  deleteSrDocumentType,
} from 'actions/srDocuments/srDocumentTypeActions'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'

const SrDocumentTypeDelete = ({ formId, closeModal, selected }) => {
  //// HOOKS.
  const dispatch = useDispatch()

  //// GLOBAL STATE.

  //// LOCAL STATE.

  //// LIFECYCLE HELPERS.

  //// MEMOS.

  //// EFFECTS.
  useEffect(() => {
    return () => {
      dispatch(clearSrDocumentTypeAction())
    }
  }, [dispatch])

  //// RENDER VARS & HELPERS.

  //// RENDER.
  return (
    <form
      id={formId}
      onSubmit={(e) => {
        e.preventDefault()
        dispatch(deleteSrDocumentType(selected))
        closeModal()
      }}
      className="form container"
    >
      <div>
        Are you sure you want to delete this site readiness document type? This
        can not be undone.
      </div>
    </form>
  )
}

export default SrDocumentTypeDelete
